function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import AssetComponent from "components/core/asset/asset-component";
import Button from "segments/desktop/core-components/button/button";
import Colors from "styles/colors";
import { getImagePositionStyles } from "segments/desktop/core-components/images-grid/images-grid-service";
import classnames from "classnames";
import Title from "segments/desktop/core-components/title/title";
import VerticalTimerTabComponent from "./vertical-timer-tab-desktop/vertical-timer-tab-desktop-component";
import { StyledTimerVerticalTabsDesktopComponent } from "./timer-vertical-tabs-desktop-component.scss";
import { DEFAULT_TAB_TIMER } from "../../constants/timer";
class TimerVerticalTabsDesktopComponent extends PureComponent {
    componentDidUpdate(prevProps) {
        const { selectedTabIndex } = this.props;
        selectedTabIndex !== prevProps.selectedTabIndex && this.setState({
            selectedTab: selectedTabIndex
        });
    }
    componentDidMount() {
        const { timerEnabled, onTabChangedHandler, tabs } = this.props;
        const { selectedTab } = this.state;
        onTabChangedHandler === null || onTabChangedHandler === void 0 ? void 0 : onTabChangedHandler(tabs[selectedTab]);
        if (!timerEnabled) return;
        this.startInterval();
    }
    handleOnMouseOver() {
        const { timerEnabled } = this.props;
        if (!timerEnabled) return;
        this.setState({
            forceProgressbarDone: true
        });
        this.stopInterval();
    }
    handleOnMouseLeave() {
        const { timerEnabled } = this.props;
        if (!timerEnabled) return;
        this.setState({
            forceProgressbarDone: false
        });
        this.startInterval();
    }
    setSelectedTab(newSelectedTab) {
        const { isCollapsable, onTabChangedHandler, tabs } = this.props;
        const { selectedTab } = this.state;
        const tabToSelect = isCollapsable && newSelectedTab === selectedTab ? null : newSelectedTab;
        onTabChangedHandler === null || onTabChangedHandler === void 0 ? void 0 : onTabChangedHandler(tabs[tabToSelect]);
        this.setState({
            selectedTab: tabToSelect,
            forceProgressbarDone: false
        });
        this.startInterval();
    }
    startTabInterval() {
        var _tabs_selectedTab;
        const { selectedTab } = this.state;
        const { tabs, isCollapsable } = this.props;
        if (isCollapsable) return;
        this.tabsInterval = setInterval(()=>{
            const nextTab = (selectedTab + 1) % tabs.length;
            this.setSelectedTab(nextTab);
        }, parseInt((_tabs_selectedTab = tabs[selectedTab]) === null || _tabs_selectedTab === void 0 ? void 0 : _tabs_selectedTab.timer) || DEFAULT_TAB_TIMER);
    }
    clearTabInterval() {
        const { isCollapsable } = this.props;
        if (isCollapsable) return;
        clearInterval(this.tabsInterval);
    }
    startInterval() {
        const { timerEnabled } = this.props;
        if (timerEnabled) {
            this.stopInterval();
            this.startTabInterval();
        }
    }
    stopInterval() {
        const { timerEnabled } = this.props;
        if (timerEnabled) {
            this.clearTabInterval();
        }
    }
    renderTabs() {
        const { selectedTab, forceProgressbarDone } = this.state;
        const { tabs, showDivider, timerEnabled, tabContentRenderer, showArrow, progressbarColor, alwaysShowProgressbar, arrowSize, tabTitleRenderer, title, getTabIdentifier } = this.props;
        const { fontSize, selectedFontSize, fontColor, selectedFontColor, fontWeight, lineHeight } = title || {};
        return tabs.map((tab, index)=>{
            const { title, content, badgeText, timer, overrideTabFontColor } = tab, rest = _object_without_properties(tab, [
                "title",
                "content",
                "badgeText",
                "timer",
                "overrideTabFontColor"
            ]);
            return /*#__PURE__*/ _jsxs("div", {
                className: "tab",
                role: "tablist",
                children: [
                    showDivider && index != 0 && /*#__PURE__*/ _jsx("div", {
                        className: "tabs-divider"
                    }),
                    /*#__PURE__*/ _jsx(VerticalTimerTabComponent, _object_spread({
                        index: index,
                        getTabIdentifier: getTabIdentifier,
                        isSelected: index === selectedTab,
                        title: title,
                        content: content,
                        badgeText: badgeText,
                        duration: timer || DEFAULT_TAB_TIMER,
                        forceProgressbarDone: forceProgressbarDone,
                        setSelectedTab: this.setSelectedTab,
                        showArrow: showArrow,
                        timerEnabled: timerEnabled,
                        fontSize: fontSize,
                        lineHeight: lineHeight,
                        selectedFontSize: selectedFontSize,
                        fontColor: overrideTabFontColor !== null && overrideTabFontColor !== void 0 ? overrideTabFontColor : fontColor,
                        selectedFontColor: overrideTabFontColor !== null && overrideTabFontColor !== void 0 ? overrideTabFontColor : selectedFontColor,
                        progressbarColor: progressbarColor,
                        alwaysShowProgressbar: alwaysShowProgressbar,
                        arrowSize: arrowSize,
                        tabTitleRenderer: tabTitleRenderer,
                        tabContentRenderer: tabContentRenderer,
                        titleFontWeight: fontWeight
                    }, rest))
                ]
            }, index);
        });
    }
    renderAllRightSideContent() {
        const { tabs } = this.props;
        const { selectedTab } = this.state;
        return /*#__PURE__*/ _jsx("div", {
            className: "right-side-container",
            children: tabs.map((tab, index)=>/*#__PURE__*/ _jsx("div", {
                    className: classnames("right-side-tab-content-container", {
                        hidden: index !== selectedTab
                    }),
                    children: this.renderRightSide(index)
                }, index))
        });
    }
    renderRightSide(selectedTab) {
        var _tabs_selectedTab, _tabs_selectedTab_asset_image, _tabs_selectedTab_asset, _tabs_selectedTab_asset_video, _tabs_selectedTab_asset1, _tabs_selectedTab1, _tabs_selectedTab2;
        const { assetQuality, hideControls, useWindowMask, tabs, backgroundColor, rightSideRenderer, assetPosition } = this.props;
        const shouldDisplayImage = ((_tabs_selectedTab = tabs[selectedTab]) === null || _tabs_selectedTab === void 0 ? void 0 : _tabs_selectedTab.asset) && ((_tabs_selectedTab_asset = tabs[selectedTab].asset) === null || _tabs_selectedTab_asset === void 0 ? void 0 : (_tabs_selectedTab_asset_image = _tabs_selectedTab_asset.image) === null || _tabs_selectedTab_asset_image === void 0 ? void 0 : _tabs_selectedTab_asset_image.src) || ((_tabs_selectedTab1 = tabs[selectedTab]) === null || _tabs_selectedTab1 === void 0 ? void 0 : (_tabs_selectedTab_asset1 = _tabs_selectedTab1.asset) === null || _tabs_selectedTab_asset1 === void 0 ? void 0 : (_tabs_selectedTab_asset_video = _tabs_selectedTab_asset1.video) === null || _tabs_selectedTab_asset_video === void 0 ? void 0 : _tabs_selectedTab_asset_video.src);
        if (!shouldDisplayImage && rightSideRenderer) return rightSideRenderer(tabs[selectedTab]);
        const assetPositionStyle = getImagePositionStyles(assetPosition);
        const assetInnerStyle = _object_spread_props(_object_spread({}, assetPositionStyle), {
            backgroundColor: Colors[backgroundColor]
        });
        return /*#__PURE__*/ _jsx("div", {
            className: "desktop-asset-container",
            children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread_props(_object_spread({}, (_tabs_selectedTab2 = tabs[selectedTab]) === null || _tabs_selectedTab2 === void 0 ? void 0 : _tabs_selectedTab2.asset), {
                assetQuality: assetQuality,
                hideControls: hideControls,
                useWindowMask: useWindowMask,
                convertGifToVideo: true,
                className: "tab-asset-inner",
                imageClassName: "tab-asset-image",
                style: assetInnerStyle
            }))
        });
    }
    render() {
        const { showButton, buttonConfig, isFullScreen, tabsTitle, tabsContainerClassName, isTabsFullWidth, prerenderTabs } = this.props;
        const { selectedTab } = this.state;
        return /*#__PURE__*/ _jsxs(StyledTimerVerticalTabsDesktopComponent, {
            className: classnames("timer-vertical-tabs-desktop-component", {
                "full-screen": isFullScreen
            }),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "vertical-timer-tabs-container",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: classnames("desktop-tabs-text-container", {
                                [tabsContainerClassName]: tabsContainerClassName
                            }),
                            style: {
                                width: isTabsFullWidth && "100%"
                            },
                            onFocus: this.handleOnMouseOver,
                            onBlur: this.handleOnMouseLeave,
                            onMouseOver: this.handleOnMouseOver,
                            onMouseLeave: this.handleOnMouseLeave,
                            children: [
                                (tabsTitle === null || tabsTitle === void 0 ? void 0 : tabsTitle.title) && /*#__PURE__*/ _jsx("div", {
                                    className: "tabs-paragraph-wrapper",
                                    children: /*#__PURE__*/ _jsx(Title, _object_spread({}, tabsTitle))
                                }),
                                this.renderTabs()
                            ]
                        }),
                        /*#__PURE__*/ _jsx(SwitchTransition, {
                            mode: "out-in",
                            children: /*#__PURE__*/ _jsx(CSSTransition, {
                                classNames: "fade",
                                timeout: 200,
                                children: prerenderTabs ? this.renderAllRightSideContent() : this.renderRightSide(selectedTab)
                            }, selectedTab)
                        })
                    ]
                }),
                showButton && /*#__PURE__*/ _jsx("div", {
                    className: "button-link",
                    children: /*#__PURE__*/ _jsx(Button, _object_spread({}, buttonConfig))
                })
            ]
        });
    }
    constructor(props){
        super(props);
        const { isCollapsable, selectedTabIndex } = this.props;
        this.state = {
            selectedTab: (selectedTabIndex !== null && selectedTabIndex !== void 0 ? selectedTabIndex : isCollapsable) ? null : 0,
            forceProgressbarDone: false
        };
        this.tabsInterval = null;
        this.handleOnMouseLeave = this.handleOnMouseLeave.bind(this);
        this.handleOnMouseOver = this.handleOnMouseOver.bind(this);
        this.setSelectedTab = this.setSelectedTab.bind(this);
        this.startTabInterval = this.startTabInterval.bind(this);
        this.clearTabInterval = this.clearTabInterval.bind(this);
        this.startInterval = this.startInterval.bind(this);
        this.stopInterval = this.stopInterval.bind(this);
        this.renderTabs = this.renderTabs.bind(this);
    }
}
export { TimerVerticalTabsDesktopComponent as default };
